module.exports = __webpack_public_path__ + "img/settings_white_icon.d60140d4.svg";